<template>
  <div v-if="show_shadow_view" class="createCropperShadow" @click.self="hideShadowView()">
    <div class="createCropperView">
      <span class="close" @click="hideShadowView()">
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "ShadowView",
  props: {
  },
  components: {
  },
  data() {
    return {
      show_shadow_view: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    // -----shadow 事件
    showShadowView(){
      this.show_shadow_view = true
    },
    hideShadowView(){
      this.show_shadow_view = false
    },
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.createCropperShadow{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .createCropperView{
    width: 100%;
    border-radius: 5px;
    // overflow: hidden;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top:0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
  }
}
</style>
